import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-t border-line bg-panel px-5 py-20" data-id="element-24" data-mp="1lc20peakr5rp">
      <div className="mx-auto max-w-3xl" data-id="element-25" data-mp="1gdqqh2gdat8y">
        <h2 className="text-center font-display text-4xl uppercase text-cream sm:text-5xl" data-id="element-26" data-mp="1gal25pfkbvea">
          Questions <span className="text-gold" data-id="element-27" data-mp="2dy3jhonai5tw">fréquentes</span>
        </h2>
        <div className="mt-10 divide-y divide-line border-y border-line" data-id="element-28" data-mp="292o4uuhgk5wf">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-29" data-mp="1z3yo551asrhr" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left text-lg font-semibold text-cream" data-id="element-30" data-mp="1z2njz43xxhq4">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden data-id="element-31" data-mp="pj94bhman5jy" />
                </button>
                <AnimatePresence initial={false} data-id="element-32" data-mp="fm4en7t8orye">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-33" data-mp="kkxvna7qj13b">
                      <p className="pb-5 text-mute" data-id="element-34" data-mp="1teul8x9tx3x">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}